import { FieldProps, FieldVariant, SectionLayout, SectionVariant } from "../InputFieldsController/InputFieldsController.utils";

export interface ColumnData {
  id: string;
  fieldIds: string[];
}

export interface FormSettings {
  intakeRules?: string;
  themePreset?: string;
  fieldVariant?: FieldVariant;
  sectionVariant?: SectionVariant;
  sectionLayout?: SectionLayout;
}

export interface InputStructureProps {
  fields: FieldProps[];
  columns: Record<string, ColumnData>;
  formSettings?: FormSettings;
}

export interface FieldOption {
  value: string;
  label: string;
  type: string;
  id: string;
  code?: string;
}
export interface CygnusFormBuilderProps {
  initialData: InputStructureProps;
  updateInitialData: (newData: InputStructureProps) => void;
  templateStatus?: string;
  fieldOptions: FieldOption[];
}

/**
 * Generates a blank initialData structure for use with a new form.
 * @returns {InputStructureProps} Initial blank structure
 */
export const createDefaultInitialData = (): InputStructureProps => ({
  fields: [createDefaultFieldSchema("default_first_field_2022!!")],
  columns: {
    column: {
      id: "column",
      fieldIds: ["default_first_field_2022!!"],
    },
  },
});

/**
 * Generates a new FieldSchema object with default field settings.
 *
 * @param {string} id - Unique identifier for the new field
 * @returns {FieldSchema} New form field with default settings
 */
export const createDefaultFieldSchema = (id: string): FieldProps => {
  const defaultField: FieldProps = {
    id: id,
    type: "text",
    label: "Unititled",
    value: "",
    allfields_id: id,
    allfields_code: "custom_field",
    allfields_category: "custom",
    allfields_key: "",

    placeholder: "",
    example: "",
    disabled: false,
    show: true,
    options: [{ id, label: "", value: "" }],
    width: 20,
    breakLine: false,
    headerSize: "H4",
    source: "",
    radiogroup: "",
    margins: { top: 5, right: 5, bottom: 5, left: 5 },
    showTimeSelect: false,
    fileLimit: "single",
    uploading: false,
    labelPosition: "top",

    textStyle: {
      bold: false,
      italic: false,
      underline: false,
      strikethrough: false,
      fontSize: 10,
      color: "#000000",
      width: 100,
      margins: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },

    validation: [],
    isValid: true,
    error: "",
  };

  return defaultField;
};
